// removed by extract-text-webpack-plugin
module.exports = {"table-header":"_34-EB7kE7DULO_HWUsJOxI","sortable":"_1MTLheXY9ORhhhdOUt7q1M","icon":"fJhlkoy8bfLQD45yb7slH","active":"fdwsz5EezGpzE4Xv5tf3D","spin":"_7ephdpR13zOzqCUyQ6dLI"};


//////////////////
// WEBPACK FOOTER
// ./src/public/components/View/TableHeader/styles.scss
// module id = 919
// module chunks = 18